import gql from 'graphql-tag';

export const AlbumFolderLinkRequestDetails = gql`
  fragment AlbumFolderLinkRequestDetails on AlbumFolderLinkRequest {
    id
    status
    is_resolved
    created_at
    sender_account {
      id
      name
      username
    }
    album_folder {
      id
      name
      album_type
      album_subtype
      account {
        id
      }
    }
    target_album_folder {
      id
      name
      album_type
      album_subtype
      account {
        id
        name
        organization_name
      }
    }
  }
`;
